import { render, staticRenderFns } from "./EditarHoraDialog.vue?vue&type=template&id=f79fc708&scoped=true&lang=pug&"
import script from "./EditarHoraDialog.vue?vue&type=script&lang=js&"
export * from "./EditarHoraDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditarHoraDialog.vue?vue&type=style&index=0&id=f79fc708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79fc708",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
